import CartItems from "@client/content/modules/Cart/Items/component";
import { type Cart } from "@client/content/modules/Cart/types";
import Checkbox from "@client/controls/Inputs/Checkbox/component";
import { formatMoneyDisplay } from "@client/lib/format";
import { type WithId } from "@client/types";
import { useI18n } from "@common/hooks/i18n";
import classNames from "classnames";
import * as React from "react";
import { type OfferSettings } from "../../selectors";
import { type Checkout } from "../../types";

export type MapProps = WithId & {
  includeOffer: boolean;
  isEditMode: boolean;
  currencyCode: string;
  item: Checkout.CartItem | null;
  noImageUrl: string;
  settings: OfferSettings;
};
export interface ActionProps {
  onChange: (includeOffer: boolean) => void;
}
export type Props = ActionProps & MapProps;

export default (props: Props) => {
  const i18n = useI18n();

  const items = React.useMemo((): Cart.Api.Item[] => {
    if (!props.item) return [];

    return [props.item];
  }, [props.item]);

  if (!props.item) return null;

  return (
    <div className="offer" style={props.settings.mainContainerStyle}>
      {!!props.settings.title && <h4>{props.settings.title}</h4>}

      {!!props.settings.description && <div dangerouslySetInnerHTML={{ __html: props.settings.description }} />}

      <CartItems
        redirectOnClick={!props.isEditMode}
        imageSize={60}
        isOffer
        currencyCode={props.currencyCode}
        items={items}
        noImageUrl={props.noImageUrl}
        shouldDisplayTax={false}
      />
      <div className="footer">
        <Checkbox label={i18n.addToMyOrder} onChange={props.onChange} value={props.includeOffer} qa="Add to my order" />

        <strong className={classNames("price", { cross_out: props.item.price !== props.item.originalPrice })}>
          {formatMoneyDisplay(props.item.originalPrice, props.currencyCode)}
        </strong>

        {props.item.price !== props.item.originalPrice && (
          <strong className="price discounted">{formatMoneyDisplay(props.item.price, props.currencyCode)}</strong>
        )}
      </div>
    </div>
  );
};
